import type { ReactElement } from 'react';
import React from 'react';
import { AssignedTestInstances } from 'feature-components/assigned-test-instances';
import { useAuthCustomerUser, useIsSchool } from 'services/providers/auth.hooks';

export default function MyAssignmentsTab(): ReactElement | null {
  const customerUser = useAuthCustomerUser();
  const isSchool = useIsSchool();
  if (!customerUser) {
    return null;
  }
  return <AssignedTestInstances customerUserId={customerUser?.id} isSchool={isSchool} />;
}
